export const convertUrlImg = (filePath) => {
	const url = `${window.config.serviceManagementBackendUrl}/Documents/SparePartImage/${filePath}`
	return url
}
